<template>
  <TModal
    :title="!is_edit ? 'Create pallet type' : 'Pallet type'"
    :show="show"
    @update:show="$emit('update:show', $event)"
    @click-create="create()"
    :key="key"
  >
    <template #actions>
      <TButtonCreate
        :options="{ disabled: loading }"
        variant="outline"
        @click="create"
        v-if="!is_edit"
      />
      <TButtonSave
        variant="outline"
        @click="update"
        v-if="is_edit"
        :options="{ disabled: loading }"
      />
    </template>
    <CRow>
      <CCol col="6">
        <TInputNumber
          label="Weight"
          class="mb-3"
          :value="input.weight"
          @update:value="input.weight = $event"
        />
      </CCol>
      <CCol col="6">
        <TInputNumber
          label="Max weight"
          class="mb-3"
          :value="input.max_weight"
          @update:value="input.max_weight = $event"
        />
      </CCol>
    </CRow>
    <TInputNumber
      label="Max length"
      class="mb-3"
      :value="input.max_length"
      @update:value="input.max_length = $event"
    />
    <TInputNumber
      label="Max height"
      class="mb-3"
      :value="input.max_height"
      @update:value="input.max_height = $event"
    />
    <TInputNumber
      label="Max width"
      class="mb-3"
      :value="input.max_width"
      @update:value="input.max_width = $event"
    />
  </TModal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    palletType: {
      type: Object,
      require: false,
    },
  },
  inputDefault: {
    max_width: 0,
    max_height: 0,
    max_length: 0,
    max_weight: 0,
    weight: 0,
  },
  data() {
    return {
      key: "palletTypeModal",
      data: this.getInput(),
    };
  },
  watch: {
    palletType() {
      this.data = this.getInput();
    },
  },
  computed: {
    ...mapGetters({
      loading: "warehouse.pallet_types.loading",
    }),
    is_edit() {
      if (!this.palletType) {
        return false;
      }
      return !!this.palletType.id;
    },
    input: {
      get: function () {
        return this.data;
      },
      set: function (newValue) {
        return (this.data = newValue);
      },
    },
  },
  methods: {
    create() {
      this.$store
        .dispatch("warehouse.pallet_types.create", this.input)
        .then(() => {
          this.$emit("update:show", false);
          this.input = this.inputDefault();
        });
    },
    update() {
      this.$store
        .dispatch("warehouse.pallet_types.update", {
          id: this.palletType.id,
          attributes: this.input,
        })
        .then(() => {
          this.$emit("update:show", false);
        });
    },
    inputDefault() {
      return { ...this.$options.inputDefault };
    },
    getInput() {
      if (!this.is_edit) {
        return this.inputDefault();
      }
      return { ...this.palletType };
    },
  },
};
</script>
